import { cn, mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const SummaryItem = ({ label, value, children, enabled = false, className }) => (
  <div className={cn('flex h-10 w-full items-center justify-between', className)}>
    <div className="flex items-center gap-2">
      <Typography
        variant="label"
        size="medium"
        color={enabled ? 'neutral-900' : 'neutral-600'}
        weight="medium">
        {label}
      </Typography>
      {children}
    </div>
    <Typography variant="label" size="medium" color={enabled ? 'neutral-900' : 'neutral-600'}>
      {mString(value)}
    </Typography>
  </div>
);

export default SummaryItem;
